import "./Modal.css"
function Modal({ modalStatus, changeStatus, t, w, h, content }) {


    let wBox = (100 - w) / 2
    let hBox = "auto";
    let tBox = 10;
    if (h) {
        hBox = h
    }
    if (t) {
        tBox = t
    }
    const styleBox = {
        top: `${tBox}%`,
        width: `${w}%`,
        height: `${h}%`,
        left: `${wBox}%`,
        minWidth: "300px",




    }
   


    return (

        <div>
            {modalStatus && (
                <div className={"model-bg-m-1"} >
                    <div style={styleBox} className={`model-box-m-1`} >

                        <div className="box-x"><div onClick={() => { changeStatus(false) }} className="shd-modal-close">X</div></div>
                        <div className='model-box-content'>
                            {content}
                        </div>
                    </div>
                </div>
            )}
        </div>


    )
}

export default Modal